import { render, staticRenderFns } from "./ServiceAccounts.vue?vue&type=template&id=7928bafd&scoped=true&web=true&"
import script from "./ServiceAccounts.vue?vue&type=script&lang=ts&"
export * from "./ServiceAccounts.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceAccounts.vue?vue&type=style&index=0&id=7928bafd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7928bafd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VList,VListItem,VListItemGroup,VListItemTitle,VRow})
